document.addEventListener('turbo:load', function() {
  $('form.versand_erforderlich button').removeAttr('disabled');
  $('form.versand_erforderlich').submit(function(e) {
    e.preventDefault();
    e.stopPropagation();
    window.flash.clear();
    window.flash.add({type: 'error', message: $('.versandart_waehlen').text()});
  });
});
